import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { getWebWindow } from 'app/utils/web-window';

// Browser session storage survives reloads within a tab, and expires when that tab closes.
// If storage is blocked, Jotai still keeps the dismissal for the running app session.
const memoryStorage = new Map<string, string>();
const memoryOnlyKeys = new Set<string>();
const sessionStorage = createJSONStorage<boolean>(() => ({
  getItem(key) {
    if (memoryOnlyKeys.has(key)) return memoryStorage.get(key) ?? null;
    try {
      const browserStorage = getWebWindow()?.sessionStorage;
      return browserStorage ? browserStorage.getItem(key) : (memoryStorage.get(key) ?? null);
    } catch {
      return memoryStorage.get(key) ?? null;
    }
  },
  setItem(key, value) {
    memoryStorage.set(key, value);
    try {
      const browserStorage = getWebWindow()?.sessionStorage;
      if (!browserStorage) {
        memoryOnlyKeys.add(key);
        return;
      }
      browserStorage.setItem(key, value);
      memoryOnlyKeys.delete(key);
    } catch {
      memoryOnlyKeys.add(key);
      // Keep the in-memory dismissal when browser storage is unavailable.
    }
  },
  removeItem(key) {
    memoryStorage.delete(key);
    try {
      const browserStorage = getWebWindow()?.sessionStorage;
      if (!browserStorage) {
        memoryOnlyKeys.add(key);
        return;
      }
      browserStorage.removeItem(key);
      memoryOnlyKeys.delete(key);
    } catch {
      memoryOnlyKeys.add(key);
      // A failed removal must not expose the stale browser value.
    }
  },
}));

export const guestAppBannerDismissedAtom = atomWithStorage('guest-app-banner-dismissed', false, sessionStorage, {
  getOnInit: true,
});
export const guestLocationHintDismissedAtom = atomWithStorage('guest-location-hint-dismissed', false, sessionStorage, {
  getOnInit: true,
});
